import { render, staticRenderFns } from "./MPSettingPickerWidth.vue?vue&type=template&id=ed87d634&"
import script from "./MPSettingPickerWidth.vue?vue&type=script&lang=js&"
export * from "./MPSettingPickerWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports